var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"mx-2 mt-3 d-flex",attrs:{"flat":"","inset":"","label":_vm.label},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }